module.exports = __webpack_public_path__ + "img/3-2.646d003a.jpg";